import {RouteLocationRaw} from "vue-router";
import {Component, InjectionKey, ShallowRef} from "vue";

export interface WindowDatum {
  id: number;
  content:
    | {
        type: "route";
        href: RouteLocationRaw;
      }
    | {
        type: "component";
        component: ShallowRef< string | any>;
        props?: any;
      };
  retData?: any;
  title: string;
  width: number;
  height: number;
  padding: number;
  left: number;
  top: number;
  mini: boolean;
  zIndex: number;
  mask: boolean;
}

export interface WindowData {
  [id: string]: WindowDatum;
}

export interface WindowDatumInput {
  content:
    | {
        type: "route";
        href: RouteLocationRaw;
      }
    | {
        type: "component";
        component: ShallowRef<string | Component>;
        props?: any;
      };
  title?: string;
  width?: number;
  height?: number;
  padding?: number;
  left?: number;
  top?: number;
  mask?: boolean;
}

export interface WindowsInterface {
  open(windowDatumInput: WindowDatumInput): number;

  close(id: number): void;

  getCloseData(id: number): Promise<any>;
}

export interface WindowTool {
  setReturnData(data?: any): void;
  close(data?: any): void;
}

export const WindowTool: InjectionKey<WindowTool> = Symbol.for("WindowTool");
